export default __webpack_public_path__ + "static/media/less.18488d68.svg";